import type { ListBuilderList } from '../../../types';

/**
 * Pending Receipt list configuration
 * Shows requests with PO placed, pending receipt
 */
export const pendingReceiptList: ListBuilderList = {
	id: 'default-sourcing-requests-pending-receipt',
	cacheTTL: 300000,
	name: 'Pending Receipt',
	type: 'default',
	active: true,
	sortOrder: 8,
	filterRules: {
		sourcingRequestAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'sourcing_requests:view:any', negated: true },
				],
			},
		},
		sourcingRequestLineStatus: {
			defaultValue: [{ id: 'po_placed', label: 'PO Placed' }],
			locked: true,
			hidden: true,
		},
	},
	inheritsFrom: 'default-sourcing-requests-all',
};
